import React from 'react';
import { Typography, Grid, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useLogout } from '../../../service/auth.service';
import Loader from '../../components/loader';

function UserProfile() {

    const navigate = useNavigate();
    const { logout } = useLogout();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        userProfileData()
    }, []);

    const userProfileData = (() => {
        const currentUserData = localStorage.getItem("userData");
        setUserData(JSON.parse(currentUserData));
    })

    const handleLogout = () => {
        setLoading(true)
        logout().then((res) => {
            window.location.href = '/auth/login';
        }).catch((err) => {
            console.log('errr', err);
        });
    }

    return (
        <>
            <Grid container alignItems={'center'}>
                <Grid size={11}>
                    <Typography style={{ fontSize: 30, fontWeight: 700 }}>User Profile</Typography>
                </Grid>
                <Grid size={0.5} textAlign={'end'}>
                    <Icon icon="ei:arrow-left" onClick={() => navigate('/user')} width="30" height="30" className='backIcon' />
                </Grid>
            </Grid>

            <Grid container alignItems={'center'} mt={3}>
                <Grid size={2}>
                    <Typography sx={{ fontWeight: 900, fontSize: 16 }}>User Name </Typography>
                </Grid>
                <Grid size={8}>
                    <Typography>: &nbsp;&nbsp; {userData?.firstName} {userData?.lastName}</Typography>
                </Grid>
            </Grid>

            <Grid container alignItems={'center'} mt={3}>
                <Grid size={2}>
                    <Typography sx={{ fontWeight: 900, fontSize: 16 }}>User Type:</Typography>
                </Grid>
                <Grid size={8}>
                    <Typography>: &nbsp;&nbsp; {userData?.userType?.typeName}</Typography>
                </Grid>
            </Grid>

            <Grid container alignItems={'center'} mt={3}>
                <Grid size={2}>
                    <Typography sx={{ fontWeight: 900, fontSize: 16 }}>Short Name:</Typography>
                </Grid>
                <Grid size={8}>
                    <Typography>: &nbsp;&nbsp; {userData?.userType?.shortName}</Typography>
                </Grid>
            </Grid>

            <Grid container alignItems={'center'} mt={3}>
                <Grid size={2}>
                    <Typography sx={{ fontWeight: 900, fontSize: 16 }}>Phone Number:</Typography>
                </Grid>
                <Grid size={8}>
                    <Typography>: &nbsp;&nbsp; {userData?.countryCode} {userData?.phoneNumber}</Typography>
                </Grid>
            </Grid>

            <Grid container alignItems={'center'} mt={3}>
                <Grid size={2}>
                    <Typography sx={{ fontWeight: 900, fontSize: 16 }}>Email:</Typography>
                </Grid>
                <Grid size={8}>
                    <Typography>: &nbsp;&nbsp; {userData?.email}</Typography>
                </Grid>
            </Grid>

            {loading && <Loader />}
        </>
    )
}

export default UserProfile
